<template>
<Modal 
    :id="'cmp_bookings_booking_add_artist'"
    @cancelled="onCancelClick"  
>
    <template slot="header">
        <template>  </template>
        
    </template>
    <template slot="body">
        <div  style="text-align:center">
          <p> {{$t('minimal_income_confirmation')}}  </p>
          <TextField
            class="m1"
            :id="'min_income'"
            
            v-bind="textFieldConfig"
          
            :value="minIncome"
            :placeholder="''"
            @valuechanged="onTextFieldValueChange"
          />
        </div>

     </template>
    <template slot="options">
      
        <button  class="dt-button s7" @click="onCancelClick">{{$t('cancel')}}</button>
        <button class="dt-button s7 v1" @click="onOKClicked">{{$t('ok')}}</button>
    </template>
</Modal>
  
  
</template>

<script>
import Modal from '../../../../dt-plugins/modal/modal';

import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";


import ModalContainer from "@dtplugins/modal/modal-container";
import { DistributionStatementService } from '../../services/statement.service';




export default {
  components: {
    
    Modal,
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,
   
    //AdvanceSearch,
   
  },
  mounted:async  function () {
    //DistributionStatementService
  },
  data: function () {
    return {
        min_income:0.01,
        textFieldConfig: {
          height: 42,
          showEditIconOnHover: false,
          box: true,
        // showValidationIcons: true,
        // immediateValidation: true,
      },
    
    };
  },
   mixins: [],

  computed: {
    minIncome:function(){
      return `${this.min_income} EUR`
    },
    statement_id: function () {
      return this.$route.params.statement_id;
    },
    
  },
  methods: { 
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },

    onOKClicked:function(){
       this.$emit("change", {menu:'remove_minimal_income',statement_id:this.statement_id , min_income:this.min_income });
    },



    onTextFieldValueChange:function(key, value){
      console.log("NAME",key,value)
      key=value
    },
  
  },
};
</script>

<style lang="scss">
.cmp-catalog-releases-releases_list {
  .dt-page--body {
    --offset: 190px;
  }
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  //   .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;
     
  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>